import React from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
var featureList = [
    '✓ Complete view of application status to your Sub Agent',
    '✓ Let Sub Agents personalise university shortlists for students instantly',
    '✓ Instant application submission access to Sub Agents',
    '✓ Manage & track application process easily'
];
var BlankScreenSideTextComponent = function (_a) {
    var handleButtonClick = _a.handleButtonClick;
    return (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-3" },
        React.createElement(GBTypography, { variant: "h2Semibold", className: "lfc-text-gbTokens-primary-600" }, "Managing Subagents became easy!"),
        React.createElement(GBTypography, { variant: "h1Semibold", className: "lfc-text-[32px] lfc-font-semibold lfc-leading-[48px]" }, "Improve Student Relations & Admit Success with Unisetu"),
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-pb-2" }, featureList === null || featureList === void 0 ? void 0 : featureList.map(function (feature, index) { return (React.createElement(GBTypography, { key: index, variant: "body3Semibold", className: "lfc-text-gbTokens-grey-A900" }, feature)); })),
        React.createElement(Button, { variant: "primary", size: "large", fullWidth: false, className: "lfc-w-fit", onClick: handleButtonClick }, "Register Subagent")));
};
export default BlankScreenSideTextComponent;
//# sourceMappingURL=BlankScreenSideTextComponent.js.map